import { CommentArrowRightOutlineIcon } from './CommentArrowRightOutlineIcon';

/**
 * author: Michael Irigoyen
 * id E34BA65C-995B-4E2F-A40E-8833E55187FC
 * name comment-arrow-right-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-arrow-right-outline.svg
 * tags
 */
export const CommentNextOutlineIcon = CommentArrowRightOutlineIcon;
export default CommentNextOutlineIcon